import { CRUDApiService } from "./CRUDApiService";
import { TestCabecalhoDataType } from "app/types";
import { DashboardApiService } from "../DashboardService";

export class DashboardApiServiceImpl extends CRUDApiService
  implements DashboardApiService {
  constructor() {
    super("dashboard");
  }

  async getTestCabelhoDashAndUser(
    userId: number
  ): Promise<TestCabecalhoDataType[]> {
    const response = await this.makeHttpRequest({
      url: `/testcabecalhodashanduser?UserId=${userId}`
    });
    return response?.result as Array<TestCabecalhoDataType>;
  }
}
